export const environment = {
  production: false,
  urlApi: 'https://66n86kep4f.execute-api.us-east-1.amazonaws.com/dev/api/v1',
  // urlApi: 'https://efxgyig1va.execute-api.us-east-1.amazonaws.com/prod/api/v1',
  // urlApi: 'http://localhost:3000/api/v1',
  limits: {
    answerMaxLength: 150,
  }
};